import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PosOrderApiService, PosOrderReceiptDto } from '../data-access/pos-order-api.service';
import { PosReportsApiService } from '../data-access/pos-reports-api.service';
import { PosInformeDashboard } from '../models/pos-informe.models';
import { PosTransaccionesDashboard, PosTxRow } from '../models/pos-transacciones.models';

@Injectable()
export class PosReportsService {
  private readonly api = inject(PosReportsApiService);
  private readonly ordersApi = inject(PosOrderApiService);

  ventasDashboard(
    locationId: string,
    options: {
      reportDate?: string;
      startDatetime?: string;
      endDatetime?: string;
    } = {}
  ): Observable<PosInformeDashboard> {
    return this.api.ventasDashboard(locationId, options);
  }

  transaccionesDashboard(
    locationId: string,
    options: {
      page?: number;
      per?: number;
      startDatetime?: string;
      endDatetime?: string;
      paymentMethods?: readonly string[];
      status?: string;
      q?: string;
    } = {}
  ): Observable<PosTransaccionesDashboard> {
    return this.api.transaccionesDashboard(locationId, options);
  }

  cancelOrder(
    id: string,
    note: string,
    idempotencyKey?: string | null
  ): Observable<{ errors: string[] }> {
    return this.api.cancelOrder(id, note, idempotencyKey);
  }

  getOrderForReceipt(id: string): Observable<PosOrderReceiptDto | null> {
    return this.ordersApi.getForReceipt(id);
  }

  /** Pedido único por id (deep-link `?orderId=` desde Finanzas u otros módulos). */
  getOrderTxRow(id: string): Observable<PosTxRow | null> {
    return this.ordersApi.getForTxRow(id);
  }
}
